import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import { Box, Collapse, Grid, Tooltip, Typography } from '@mui/material'
import { memo, useCallback, useMemo, useState } from 'react'

/** TRANSLATION */
import { useTranslation } from 'react-i18next'

/** UTILS | CONSTANTS */
import { colors } from 'constants/theme'

/** COMPONENT */
import { faSearch } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import InfoIcon from '@mui/icons-material/Info'
import PromotionsApi from 'api/promotion/promotion.api'
import VoucherApi, { VoucherPaymentFindByCodeProps } from 'api/voucher/voucher.api'
import IconClinicDisabeld from 'assets/icon/icon-clinic-disabeld'
import IconGiftVoucher from 'assets/icon/icon-gift-voucher'
import IconPromotion from 'assets/icon/icon-promotion'
import InputCheckbox from 'component/Input/InputCheckbox'
import InputTextField from 'component/Input/InputTextField'
import { notiError } from 'component/notifications/notifications'
import { ModalVoucherSelectLot } from 'component/Treatments/PopupManageTreatmentCourse'
import * as UseStyled from 'features/finance/payment/component/popupPaymentTemp/UseStyledFormPayment'
import { BoxFormCollapse } from 'features/setting/branch-service-point/branch/style'
import _ from 'lodash'
import MainButton from 'new-components/buttons/main-button'
import { getBranch } from 'utils/app.utils'
import PrivilegeList from './PrivilegeList'



type PrivilegeProps = {
    listOrderPayment: any
    paymentChannels: any
    handleValueChannel: (paymentChannelId: number, value: any) => void
    isAdvancePayment: boolean
    promotionList: any
    voucherList: any
    listOrder: any
    handleSelectPaymentChannel: (channel: any) => void
    handleCheckBox: (paymentChannelId: number, type: string, id: any) => void
    handleSelectBenefit: (treatmentRight: any) => void
    handleValuePaidItem: (paymentChannelId: number, value: any, type: string, id: any, patientTreatmentRightId: number) => void
    handleChangValueTreatmentRight?: (paymentChannelId: number, patientTreatmentRightId: number, value: any) => void
    handleCheckBoxItemTreatmentRight?: (paymentChannelId: number, patientTreatmentRightId: number, value: any, type: string, id: any) => void
    handleRemoveVoucher?: (voucherListId: number) => void
    handleRemovePromotion?: (promotionBranchId: number) => void
    balancePaid?: number
    disableFiled?: boolean | false
    disableIcon?: boolean | false
    onChangePaid?: (val: number) => void
    patientId?: number
    overdue?: number
    date?: string
    systemConfig: {
        isUseCrm: boolean
        isUseNhso: boolean
        menu: 'PAYMENT' | 'OVERDUE' | 'RETROSPECTIVE' | 'EDIT_PAYMENT'
        patientCaseId: number
    }
}

function Privilege(props: PrivilegeProps) {
    const { t } = useTranslation()
    const selectedVoucherIds = useMemo(() => Object.keys(props.listOrderPayment?.vouchers || {}).length, [props.listOrderPayment?.vouchers])
    const selectedPromotionIds = useMemo(() => Object.keys(props.listOrderPayment?.promotions || {}).length, [props.listOrderPayment?.promotions])

    const countCheckedApplications = useCallback((bucket: Record<string, any> | undefined): number => {
        if (!bucket) return 0
        return Object.values(bucket).reduce((sum: number, entry: any) => {
            const itemChannel = entry?.itemChannel || {}
            const checkedCount = Object.values(itemChannel).filter((c: any) => c?.checked).length
            return sum + checkedCount
        }, 0)
    }, [])
    const [open, setOpen] = useState<boolean>(selectedVoucherIds > 0 || selectedPromotionIds > 0 || !!props.listOrderPayment.voucher?.voucherListId || !!(props.listOrderPayment.promotion?.promotionBranchId))

    const [checkedVoucher, setCheckedVoucher] = useState<boolean>(false)
    const [code, setSearchCode] = useState<string>("")
    const [errorSearchVoucher, setErrorSearchVoucher] = useState<string>("")
    const [popVoucherSelectLot, setPopVoucherSelectLot] = useState<boolean>(false)
    const [dataPopVoucherSelectLot, setDataPopVoucherSelectLot] = useState<any>({})



    // Default values for rendering
    // const channelShow = [7, 8]
    const channelShow = [7]

    const disableChannel: any = {}

    const tooltipTitle = t('PAYMENT.FORM_PAYMENT.PRIVILEGES_PROMOTION_TOOLTIP')

    // Placeholder functions
    // ✅ OPTIMIZED: Memoized popup handlers
    const onOpenPopVoucherSelectLot = useCallback((item: any) => {
        setDataPopVoucherSelectLot(item)
        setPopVoucherSelectLot(true)
    }, [])

    const onClerPopVoucherSelectLot = useCallback(() => {
        setDataPopVoucherSelectLot({})
        setPopVoucherSelectLot(false)
    }, [])

    // ✅ OPTIMIZED: Memoized voucher select handler
    const handleVoucherSelect = useCallback((item?: any) => {
        onLoadVoucher(item?.voucherCode)
        onClerPopVoucherSelectLot()
    }, [props.handleSelectBenefit])


    const handleVoucherError = useCallback((error: any) => {
        if (error?.statusCode === 404) {
            if (error.message === "NOT_FOUND_VOUCHER_CODE") {
                setErrorSearchVoucher(t(`PAYMENT.MESSAGE.ERROR.${error.message}`))
            } else {
                notiError(t(`PAYMENT.MESSAGE.ERROR.${error.message}`))
            }
        } else {
            notiError(t(`เกิดข้อผิดพลาด`))
        }
    }, [t])

    // ✅ OPTIMIZED: Memoized voucher loader
    const branchId = useMemo(() => getBranch(), [])

    const onLoadVoucher = useCallback(async (searchVoucher: string) => {
        if (!searchVoucher || searchVoucher === '') return

        const condition: VoucherPaymentFindByCodeProps = {
            code: searchVoucher,
        }

        // Handle RETROSPECTIVE order case
        if (props.systemConfig.menu === 'RETROSPECTIVE') {
            await PromotionsApi.findPromotionTreatments({
                branchId: branchId,
                patientId: Number(props.patientId),
                items: _.map(props.listOrder, (item) => ({
                    itemType: item.group || 'OPERATIVE',
                    itemId: item.operativeId || item.itemId,
                    qty: item.qty
                })),
                totalPrice: Number(props.overdue),
                date: props.date,
                code: searchVoucher,
            })
                .then((resp) => props.handleSelectBenefit(resp?.data))
                .catch((err) => handleVoucherError(err?.response?.data))
        } else {
            await VoucherApi.findVoucherPaymentByCode(props.systemConfig?.patientCaseId || 0, condition)
                .then((res) => props.handleSelectBenefit(res?.data))
                .catch((err) => handleVoucherError(err?.response?.data))
        }
    }, [props.handleSelectBenefit, props.systemConfig.menu, props.systemConfig.patientCaseId, props.patientId, props.listOrder, props.overdue, props.date, branchId, handleVoucherError])

    const selectedVouchersList = useMemo(() => Object.values(props.listOrderPayment?.vouchers || {}).filter((v: any) => v?.voucherListId), [props.listOrderPayment?.vouchers])
    const availableVoucherList = useMemo(() => {
        const selectedIds = Object.keys(props.listOrderPayment?.vouchers || {})
        const list = Array.isArray(props.voucherList) ? props.voucherList : []
        return list.filter((v: any) => !selectedIds.includes(String(v?.voucherListId)))
    }, [props.voucherList, props.listOrderPayment?.vouchers])

    const selectedPromotionsList = useMemo(() => Object.values(props.listOrderPayment?.promotions || {}).filter((p: any) => p?.promotionBranchId), [props.listOrderPayment?.promotions])
    const availablePromotionList = useMemo(() => {
        const selectedIds = Object.keys(props.listOrderPayment?.promotions || {})
        const list = Array.isArray(props.promotionList) ? props.promotionList : []
        return list.filter((p: any) => !selectedIds.includes(String(p?.promotionBranchId)))
    }, [props.promotionList, props.listOrderPayment?.promotions])

    const renderVoucher = () => {
        if (availableVoucherList?.length === 0 && selectedVouchersList.length === 0) {
            return (
                <Box width={"100%"} padding={'16px 0 0 62px'} alignContent={'center'} textAlign={'center'} color={'#808080'}>
                    {t('VOUCHER.POP_PRODUCT.FORM.VOUCHER_NONE')}
                </Box>
            )
        }
        if (availableVoucherList?.length) {
            return (
                <Box width={"100%"} padding={'16px 0 0 62px'} display={'flex'} flexDirection={'column'} gap={'8px'}>
                    {availableVoucherList.map((item: any, index: number) => (
                        <Box key={item?.voucherListId ?? index} display={'flex'} alignItems={'center'} flexWrap={'wrap'}>
                            <Box width={'140px'}>
                                {t('VOUCHER.POP_PRODUCT.FORM.VOUCHER_NAME')}
                            </Box>
                            <Box display={'flex'} alignItems={'center'} gap={'8px'}>
                                <Box display={'flex'} alignItems={'center'} gap={'8px'}>
                                    {item?.voucherName}
                                    {item?.detail && (
                                        <span>
                                            <Tooltip title={item.detail} placement={'top-start'} sx={{ 'path': { fill: '#A8A8A8' } }}>
                                                <InfoIcon />
                                            </Tooltip>
                                        </span>
                                    )}
                                </Box>
                                <Box
                                    sx={{
                                        textDecoration: 'underline',
                                        color: colors.themeSecondColor,
                                        cursor: 'pointer',
                                        width: 'fit-content',
                                        paddingLeft: '8px'
                                    }}
                                    onClick={() => onOpenPopVoucherSelectLot(item)}
                                >
                                    {t('VOUCHER.POP_PRODUCT.FORM.VOUCHER_SELECT_INDEX', { index: item?.voucherDetails?.length || 0 })}
                                </Box>
                            </Box>
                        </Box>
                    ))}
                </Box>
            )
        }
        return (
            <Box width={"100%"} padding={'16px 0 0 62px'} alignContent={'center'} textAlign={'center'} color={'#808080'}>
                    {t('VOUCHER.POP_PRODUCT.FORM.VOUCHER_NONE')}
                </Box>
        )
    }
    const oChangePaymentCannel = (item: any) => {
        props.handleSelectPaymentChannel(item)
    }

    const collapseBackgroundColor = useMemo(() =>
        props.systemConfig.isUseCrm ? '' : '#d0cece',
        [props.systemConfig.isUseCrm]
    )

    const totalPromotionVoucherCount = useMemo(() =>
        (channelShow.includes(7) ? (Array.isArray(props.voucherList) ? props.voucherList.length : 0) : 0) +
        (channelShow.includes(8) ? (Array.isArray(props.promotionList) ? props.promotionList.length : 0) : 0),
        [props.promotionList, props.voucherList]
    )
    const voucher = useMemo(() => (props.listOrderPayment?.voucher), [props.listOrderPayment?.voucher])
    const isUseCrm = useMemo(() => (props.systemConfig.isUseCrm), [props.systemConfig.isUseCrm])

    return (
        <>
            <Box padding={'0 16ox'} marginBottom={'8px'} >
                <Tooltip title={tooltipTitle} placement={'top'}>
                    <BoxFormCollapse sx={{ backgroundColor: collapseBackgroundColor }}>
                        {isUseCrm ? (
                            <Box fontSize={'18px'} fontWeight={'500'}>
                                {t('PAYMENT.FORM_PAYMENT.PRIVILEGES_PROMOTION', { index: totalPromotionVoucherCount })}
                            </Box>
                        ) : (
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px', 'img': { width: '24px', height: '24px' } }}>
                                <Box fontSize={'18px'} fontWeight={'500'}>
                                    {t('PAYMENT.FORM_PAYMENT.PRIVILEGES_PROMOTION_')}
                                </Box>
                                <IconClinicDisabeld />
                            </Box>
                        )}
                        <Box
                            className={`box-icon-expand-more`}
                            sx={{ transform: `rotate(${open ? 180 : 0}deg)`, pointerEvents: isUseCrm ? 'auto' : 'none' }}
                            onClick={() => setOpen(!open)}
                        >
                            <ExpandMoreIcon
                                sx={{
                                    backgroundColor: colors.white,
                                    border: `0.5px solid ${colors.textLightGray}`,
                                    borderRadius: '50px',
                                    color: colors.themeMainColor
                                }}
                            />
                        </Box>
                    </BoxFormCollapse>
                </Tooltip>

                <Collapse in={open}  >
                    <Box padding={'16px'}>
                        <Grid container spacing={1} className="mt-0" sx={{ display: 'flex', flexWrap: 'wrap', gap: '8px 0' }}>

                            {_.map(Object.values(props.paymentChannels), (item: any, index: number) => {
                                if (props.isAdvancePayment && item.key === "PROMOTION") return
                                if (!channelShow.includes(item?.paymentChanel)) return

                                const key = `${item.key.toLowerCase()}List`
                                const newProps: any = { ...props }
                                const itemLength = item?.paymentChanel === 7
                                    ? countCheckedApplications(props.listOrderPayment?.vouchers)
                                    : item?.paymentChanel === 8
                                        ? countCheckedApplications(props.listOrderPayment?.promotions)
                                        : (newProps?.[key]?.length || 0)
                                return (
                                    <Grid item xs={3} className=""
                                        sx={{
                                            minWidth: 'calc(100% / 3)',
                                            maxWidth: 'calc(100% / 3)',
                                            minHeight: '50px',
                                            maxHeight: '50px',
                                            paddingTop: '0px !important',
                                            display: 'block',
                                        }}
                                        key={index}
                                    >
                                        <UseStyled.ChannelBox
                                            onClick={() => props.systemConfig.menu !== 'EDIT_PAYMENT' && oChangePaymentCannel(item)}
                                            className={`align-items-center px-2 px-sm-0 text-ellipsis ${item.isActive ? 'active' : ''}`}
                                            sx={{
                                                display: 'flex',
                                                justifyContent: 'flex start !important',
                                                paddingLeft: '24px !important',
                                                gap: '8px',
                                                width: '100%',
                                                height: '100%',
                                                borderWidth: '2.5px !important',
                                                '.number': {
                                                    paddingLeft: ' 4px !important',
                                                    textAlign: 'left'
                                                },
                                                'svg': {
                                                    height: '29px !important'
                                                },
                                                '.MuiTypography-root': {
                                                    width: 'fit-content !important'
                                                },
                                                ...disableChannel
                                            }}
                                        >
                                            {item?.isActive && <p className={'number'}>{item.channelIndex}</p>}
                                            <Box sx={{ svg: { minWidth: '30px', height: '50px !important', filter: item.isActive ? '' : 'grayscale(1)', opacity: item.isActive ? '' : '.6' } }}>
                                                {item.key === 'VOUCHER' && <IconGiftVoucher />}
                                                {item.key === 'PROMOTION' && <IconPromotion />}
                                            </Box>
                                            <Tooltip title={t(`PAYMENT.FORM_PAYMENT.PAYMENT_METHODS.OPTION.${item.key}_LENGTH`, { index: itemLength })} arrow placement="right">
                                                <Typography className="pl-2 pl-sm-0 pt-sm-1 text-ellipsis channel-name">{t(`PAYMENT.FORM_PAYMENT.PAYMENT_METHODS.OPTION.${item.key}_LENGTH`, { index: (itemLength || 0) })}</Typography>
                                            </Tooltip>
                                        </UseStyled.ChannelBox>
                                    </Grid>
                                )
                            })}

                        </Grid>
                    </Box>
                </Collapse >
                {
                    Object.values(props.paymentChannels)
                        .sort((a: any, b: any) => (a.channelIndex ?? 9999) - (b.channelIndex ?? 9999)).map((item: any, index: number) => {
                            const paymentChannelId = item?.paymentChanel
                            const isActive = item?.isActive
                            const channelIndex = item?.channelIndex
                            const paidChannel = props.listOrderPayment?.paidChannel?.[paymentChannelId]
                            const itemChannel = paidChannel?.itemChannel || {}

                            if (!channelShow.includes(paymentChannelId)) return
                            if (isActive && paymentChannelId === 8) {
                                return (
                                    <Box key={`box-promotion-${index}`} padding={'16px'}>
                                        <UseStyled.TitlePayment>
                                            {`${channelIndex}. `}
                                            {t(`PAYMENT.FORM_PAYMENT.PAYMENT_METHODS.OPTION.${item.key}`)}
                                        </UseStyled.TitlePayment>
                                        <Box padding={'16px 0 0 0'} fontWeight={500} >
                                            {t('PAYMENT.FORM_PAYMENT.SUM_NET_PROMOTION')}
                                        </Box>
                                        <Box>
                                            {/* โปรโมชันที่เลือกแล้ว */}
                                            {selectedPromotionsList.length > 0 && (
                                                <Box
                                                    sx={{
                                                        padding: '12px 16px',
                                                        marginBottom: '16px',
                                                        borderRadius: '8px',
                                                        backgroundColor: 'rgba(0,0,0,0.03)',
                                                        border: '1px solid',
                                                        borderColor: 'rgba(0,0,0,0.12)',
                                                    }}
                                                >
                                                    <Box padding={'0 0 8px 0'} fontWeight={600} fontSize={'0.875rem'}>
                                                        {t('PAYMENT.FORM_PAYMENT.PROMOTION_SELECTED_COUNT', { count: selectedPromotionsList.length })}
                                                    </Box>
                                                    {selectedPromotionsList.map((promoItem: any, idx: number) => {
                                                        const pId = promoItem?.promotionBranchId
                                                        const pItemChannel = promoItem?.itemChannel ?? {}
                                                return (
                                                    <PrivilegeList
                                                                key={`promotion-${pId}-${idx}`}
                                                                listOrder={props.listOrder}
                                                                listOrderPayment={props.listOrderPayment}
                                                                paidChannel={paidChannel}
                                                                itemChannel={pItemChannel}
                                                                handleCheckBox={(type: string, id: any) => props.handleCheckBox(paymentChannelId, type, id)}
                                                                handleValueChannel={(value: any) => props.handleValueChannel(paymentChannelId, value)}
                                                                handleValuePaidItem={(value: any, type: string, id: any) => props.handleValuePaidItem(paymentChannelId, value, type, id, pId)}
                                                                handleSelectBenefit={props.handleSelectBenefit}
                                                                handleChangValueTreatmentRight={(value: any) => props.handleChangValueTreatmentRight?.(paymentChannelId, pId, value)}
                                                                handleCheckBoxItemTreatmentRight={(value: any, type: string, id: any) => props.handleCheckBoxItemTreatmentRight?.(paymentChannelId, pId, value, type, id)}
                                                                disableIcon={false}
                                                                systemConfig={{ ...props.systemConfig, type: 'PROMOTION' }}
                                                                patientTreatmentRightId={pId}
                                                                index={idx}
                                                                title={promoItem?.promotionName ?? ''}
                                                                disableFiled={props.disableFiled}
                                                                treatmentRight={promoItem}
                                                                onCallbackDel={props.handleRemovePromotion ? () => props.handleRemovePromotion?.(pId) : undefined}
                                                            />
                                                        )
                                                    })}
                                                </Box>
                                            )}
                                            {/* เลือกโปรโมชันเพิ่ม */}
                                            {availablePromotionList?.map((promoItem: any, promoIndex: number) => (
                                                <PrivilegeList
                                                    key={`promo-available-${promoItem?.promotionBranchId}-${promoIndex}`}
                                                        listOrder={props.listOrder}
                                                        listOrderPayment={props.listOrderPayment}
                                                        paidChannel={paidChannel}
                                                        itemChannel={itemChannel}
                                                        handleCheckBox={(type: string, id: any) => props.handleCheckBox(paymentChannelId, type, id)}
                                                        handleValueChannel={(value: any) => props.handleValueChannel(paymentChannelId, value)}
                                                    handleValuePaidItem={(value: any, type: string, id: any) => props.handleValuePaidItem(paymentChannelId, value, type, id, promoItem.promotionBranchId)}
                                                        handleSelectBenefit={props.handleSelectBenefit}
                                                    handleChangValueTreatmentRight={(value: any) => props.handleChangValueTreatmentRight?.(paymentChannelId, promoItem.promotionBranchId, value)}
                                                    handleCheckBoxItemTreatmentRight={(value: any, type: string, id: any) => props.handleCheckBoxItemTreatmentRight?.(paymentChannelId, promoItem.promotionBranchId, value, type, id)}
                                                        disableIcon={false}
                                                    systemConfig={{ ...props.systemConfig, type: 'PROMOTION' }}
                                                    patientTreatmentRightId={promoItem.promotionBranchId}
                                                    index={promoIndex}
                                                    title={promoItem?.promotionName ?? ''}
                                                        disableFiled={props.disableFiled}
                                                    treatmentRight={promoItem}
                                                    />
                                            ))}
                                        </Box>
                                    </Box>
                                )
                            }
                            if (isActive && paymentChannelId === 7) {
                                return (
                                    <Box key={index} padding={'16px'}>
                                        <UseStyled.TitlePayment>
                                            {`${channelIndex}. `}
                                            {t(`PAYMENT.FORM_PAYMENT.PAYMENT_METHODS.OPTION.${item.key}`)}
                                        </UseStyled.TitlePayment>
                                        <Box padding={'16px 0 0 0'} fontWeight={500} >
                                            {t('ส่วนลด Gift Voucher')}
                                        </Box>
                                        <Box>
                                            {/* รายการที่เลือกแล้ว - แสดงก่อน */}
                                            {selectedVouchersList.length > 0 && (
                                                <Box
                                                    sx={{
                                                        padding: '12px 16px',
                                                        marginBottom: '16px',
                                                        borderRadius: '8px',
                                                        backgroundColor: 'rgba(0,0,0,0.03)',
                                                        border: '1px solid',
                                                        borderColor: 'rgba(0,0,0,0.12)',
                                                    }}
                                                >
                                                    <Box padding={'0 0 8px 0'} fontWeight={600} fontSize={'0.875rem'}>
                                                        {t('PAYMENT.FORM_PAYMENT.VOUCHER_SELECTED_COUNT', { count: selectedVouchersList.length })}
                                                    </Box>
                                                    {selectedVouchersList.map((voucherItem: any, idx: number) => {
                                                        const vId = voucherItem?.voucherListId
                                                        const vItemChannel = voucherItem?.itemChannel ?? {}
                                                        return (
                                                            <PrivilegeList
                                                                key={`voucher-${vId}-${idx}`}
                                                                listOrder={props.listOrder}
                                                                listOrderPayment={props.listOrderPayment}
                                                                paidChannel={paidChannel}
                                                                itemChannel={vItemChannel}
                                                                handleCheckBox={(type: string, id: any) => props.handleCheckBox(paymentChannelId, type, id)}
                                                                handleValueChannel={(value: any) => props.handleValueChannel(paymentChannelId, value)}
                                                                handleValuePaidItem={(value: any, type: string, id: any) => props.handleValuePaidItem(paymentChannelId, value, type, id, vId)}
                                                                handleSelectBenefit={props.handleSelectBenefit}
                                                                handleChangValueTreatmentRight={(value: any) => props.handleChangValueTreatmentRight?.(paymentChannelId, vId, value)}
                                                                handleCheckBoxItemTreatmentRight={(value: any, type: string, id: any) => props.handleCheckBoxItemTreatmentRight?.(paymentChannelId, vId, value, type, id)}
                                                                disableIcon={false}
                                                                systemConfig={{ ...props.systemConfig, type: 'VOUCHER' }}
                                                                patientTreatmentRightId={vId}
                                                                index={idx}
                                                                title={`${voucherItem?.voucherCode || ''} ${voucherItem?.voucherName || ''}`}
                                                                disableFiled={props.disableFiled}
                                                                treatmentRight={voucherItem}
                                                                onCallbackDel={props.handleRemoveVoucher ? () => props.handleRemoveVoucher?.(vId) : undefined}
                                                            />
                                                        )
                                                    })}
                                                </Box>
                                            )}

                                            {/* เพิ่ม voucher */}
                                                <Box sx={{ display: 'flex', alignItems: 'center', gap: '16px', padding: "16px 14px 0 0" }}>
                                                    <Box sx={{ '.MuiCheckbox-root': { padding: '0px !important' } }}>
                                                    <InputCheckbox onChange={() => setCheckedVoucher(!checkedVoucher)} checked={checkedVoucher} />
                                                    </Box>
                                                    <Box sx={{ width: '100%', '.MuiOutlinedInput-root': { paddingRight: '9px !important' }, '.MuiFormControl-root': { position: 'relative' }, '.MuiFormHelperText-root': { position: 'absolute', bottom: '-20px' } }}>
                                                        <InputTextField
                                                            label={t('รหัส Gift Voucher')}
                                                        onchange={(event) => { setErrorSearchVoucher(""); setSearchCode(event.target.value) }}
                                                            value={code}
                                                        inputProps={{ endAdornment: <Box display={'flex'} alignItems={'center'} gap={'8px'}><FontAwesomeIcon icon={faSearch} style={{ fontSize: 15 }} /></Box> }}
                                                            helperText={errorSearchVoucher}
                                                        />
                                                    </Box>
                                                    <Box sx={{ minWidth: '100px', button: { width: '100%' } }}>
                                                    <MainButton onClick={() => onLoadVoucher(code)} title={t('เช็ครหัส')} type={'primary'} variant={'outlined'} />
                                                </Box>
                                            </Box>

                                            <Box>{renderVoucher()}</Box>
                                        </Box>
                                    </Box>
                                )
                            }

                        })
                }

            </Box >

            {
                popVoucherSelectLot &&
                <ModalVoucherSelectLot
                    onClose={onClerPopVoucherSelectLot}
                    data={dataPopVoucherSelectLot}
                    handleVoucherSelect={handleVoucherSelect}
                />
            }
        </>
    )
}

export default memo(Privilege)